export default [
    {
        id: 1,
        name: 'Combustible',
        frecuency: 'Mensual'
    },
    {
        id: 2,
        name: 'Aceite',
        frecuency: 'Mensual'
    },
    {
        id: 3,
        name: 'Llantas',
        frecuency: 'Mensual'
    },
    {
        id: 4,
        name: 'Mantenimiento',
        frecuency: 'Mensual'
    },
    {
        id: 5,
        name: 'Motor',
        frecuency: 'Mensual'
    },
    {
        id: 6,
        name: 'Administración',
        frecuency: 'Mensual'
    },
    {
        id: 7,
        name: 'Parqueadero',
        frecuency: 'Mensual'
    },
]
